import { render } from "./SurveyAdd.vue?vue&type=template&id=bb7169d8"
import script from "./SurveyAdd.vue?vue&type=script&lang=ts"
export * from "./SurveyAdd.vue?vue&type=script&lang=ts"
script.render = render

export default script